const API_BASE = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';

export default API_BASE;